import { render, staticRenderFns } from "./flightClasses.vue?vue&type=template&id=5b8d33c6&scoped=true&"
import script from "./flightClasses.vue?vue&type=script&lang=ts&"
export * from "./flightClasses.vue?vue&type=script&lang=ts&"
import style1 from "./flightClasses.vue?vue&type=style&index=1&id=5b8d33c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d33c6",
  null
  
)

export default component.exports